import { Users } from "lucide-react";
import { useSite, tx } from "@/lib/lang";
import { ui } from "@/lib/uiStrings";
import { Reveal } from "./Reveal";

export default function EnergyManager() {
  const { content, lang } = useSite();
  const t0 = ui[lang].energyManager;
  const em = content.energy_manager || {};
  const t = {
    label: tx(em.label, lang) || t0.label,
    heading: tx(em.heading, lang) || t0.heading,
    text: tx(em.text, lang) || t0.text,
  };

  return (
    <section data-testid="energy-manager-section" className="py-20 lg:py-24">
      <div className="mx-auto max-w-4xl px-6">
        <Reveal>
          <div className="bg-surface border border-royal/25 rounded-2xl p-8 lg:p-12 relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-royal/10 blur-3xl pointer-events-none" />
            <div className="flex items-center gap-2 text-azure">
              <Users size={16} />
              <span className="font-mono text-xs uppercase tracking-[0.2em]">{t.label}</span>
            </div>
            <h2 className="mt-4 font-display text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight text-ice leading-snug">
              {t.heading}
            </h2>
            <p className="mt-4 text-base text-muted-foreground leading-relaxed">{t.text}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
